import { useSettingsStore } from "~/modules/setting/stores/settings";
const INIT_MAX_PRINTER = 5
export const useGetMaxPrinter = function () {
    const settingsStore = useSettingsStore();
    const maxPrinterSetting = settingsStore.getBysettingId("max_printer", INIT_MAX_PRINTER);

    //INIT 5 (0-4) THEN ADD 1 TO (0-5) => 6 printers total (p0-p5)
    return (maxPrinterSetting.value || INIT_MAX_PRINTER) + 1;
}